import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ConsolePublisher, IPublisher, WebPublisher } from '../../shared/models';
import { EApplicationEnvironments } from '../configurations/application.config';

@Injectable()
export class LogPublishersService {
  publishers: IPublisher[] = [];

  constructor(private readonly http: HttpClient) {
    this.buildPublishers();
  }

  buildPublishers(): void {
    this.publishers.push(new ConsolePublisher());
    if (environment.application_environment !== EApplicationEnvironments.local) {
      this.publishers.push(new WebPublisher(this.http));
    }
  }
}
